/*
 * Copyright (c) 2019 3will Corporation and others.
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the 3will License v1.0
 * which accompanies this distribution, and is available at
 *
 *     http://www.3will.cn/licenses/license-v1.0
 *
 * Contributors:
 *    3will - initial API and implementation
 */
import { StyleSheet } from 'react-native';
import { TwTheme } from '@tw/tw-runtime-rn';
const theme = TwTheme.values;

export const styles = StyleSheet.create({
  container: {},
  commandContainer: {
    padding: theme.spaces[4],
    marginTop: 48
  },
  button: {
    borderRadius: 28,
    paddingHorizontal: theme.spaces[3],
    paddingVertical: theme.spaces[2],
    color: theme.primaryColors.base
  },
  label: {
    ...theme.textSizes.sm,
    color: theme.textColors.secondary
  }
});
